<script>
    export let id = '';
</script>

<tr class="prom-table__row" {id}>
    <slot></slot>
</tr>
